var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:{ 'position': _vm.hasSpinner }},[_vm._v(" © Copyright "+_vm._s(_vm.currentFullYear)+" Instituto Mix de Profissões - Todos os direitos reservados. "),_c('img',{attrs:{"src":require("@/assets/images/poweredby-white.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }